import React from 'react';
import CountUp from 'react-countup';


const FunFactS2 = (props) => {
    return (
        <section className={"" + props.hclass}>
            <h3 className="d-none"> section title</h3>
            <div className="container">
                <div className="wraper">
                    <div className="row g-0">
                        <div className="col col-lg-3 col-md-6 col-12">
                            <div className="item">
                                <i className="flaticon-user"></i>
                                <h2><CountUp end={12} enableScrollSpy /></h2>
                                <p>Committee Members</p>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-12">
                            <div className="item">
                                <i className="flaticon-charity"></i>
                                <h2><CountUp end={50} enableScrollSpy />+</h2>
                                <p>Volunteers</p>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-12">
                            <div className="item">
                                <i className="flaticon-calendar"></i>
                                <h2><CountUp end={100} enableScrollSpy />+</h2>
                                <p>Events Hosted</p>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-12">
                            <div className="item">
                                <i className="flaticon-donation"></i>
                                <h2>$<CountUp end={150} enableScrollSpy />k+</h2>
                                <p>Funds Raised</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FunFactS2;

